import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './app/App'
import './styles/app.css'

// Reaching this line means the browser parsed the bundle and evaluated every
// import above it. index.html checks for it at DOMContentLoaded and, without
// it, swaps the blank page for an "outdated browser" message.
window.__sxBooted = true

async function start() {
  // The worker always starts: it is what lets a live domain and a mocked one
  // run side by side, passing the former through and answering the latter.
  // Only a build that declares every domain live can skip it.
  if (import.meta.env.VITE_USE_MOCKS !== '0') {
    const { startMocks } = await import('./mocks/browser')
    await startMocks()
  }

  const container = document.getElementById('root')
  if (!container) throw new Error('#root is missing from index.html')

  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void start()
